module.exports = __webpack_public_path__ + "img/DE00505.ff17462b.png";